type Easing = [number, number, number, number]

export const easings: Record<string, Easing> = {
  // Material design (M3) easings
  // See documentation for detailed information on recommended use cases and duration values:
  // https://m3.material.io/styles/motion/easing-and-duration/applying-easing-and-duration
  'emphasized-accelerate': [0.3, 0, 0.8, 0.15],
  'emphasized-decelerate': [0.05, 0.7, 0.1, 1],
}
